import * as React from 'react';
import { Grid, Icon, Segment } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';

import { WS_CREAM } from '../ws/wsColors';

interface Props {
  // wsClient: WorldserviceClient;
  names: string[];
  label?: string; // if defined, this is shown at top
  nbrShown?: number;
  twoColumns?: boolean;
}

interface State {
  userErr?: string;
  first: number; // index of first entry in list shown
  nbrShown: number;
  highlightName?: string;
}

export class NameListUI extends React.Component<Props, State> {
  private DEBUG = false;
  private key = 0;

  public constructor(props: Props) {
    super(props);

    this.state = {
      first: 0,
      nbrShown: (this.props.nbrShown ? this.props.nbrShown : 10),
    };

    this.clickRespin = this.clickRespin.bind(this);
  }


  public render() {

    if (this.props.names.length === 0) {
      if (this.DEBUG) { console.log("NameListUI.render: no names"); }
      return null;
    }
    let last = this.state.first + this.state.nbrShown - 1;
    if (last >= this.props.names.length) { last = this.props.names.length - 1; }

    const list = [];
    const list2 = [];
    for (let i = this.state.first; i <= last; ++i) {
      const name = this.props.names[i];
      let item;
      // if (this.props.wsClient.isLoggedIn() && this.props.favoriteType) {
      //   const favorite = new Value(this.props.favoriteType, this.props.names[i]);
      //   item = (
      //     <p key={this.key++}>
      //       {!this.props.favorites ? null :
      //         <FavoriteStar
      //           wsClient={this.props.wsClient}
      //           favorite={favorite}
      //           selected={ValueList.has(this.props.favorites, favorite)}
      //           updateFavoriteFn={this.props.updateFavoriteFn}
      //         />
      //       }
      //       <span style={{ textAlign: "center" }}>{this.props.names[i]}</span>
      //     </p>
      //   );
      // } else {
      //   item = (<p key={this.key++}> {this.props.names[i]} </p>);
      // }

      item = (<p key={this.key++} onClick={() => this.clickName(name)}>
        <span className={name === this.state.highlightName ? "name-highlighted" : ""} >{name} </span>
      </p>);

      if ((!this.props.twoColumns) || (i % 2)) {
        list[i] = item;
      } else {
        list2[i] = item;
      }
    }

    return (
      <div>
        <div>
          {!this.props.label ? null :

            <Segment attached="top" style={{ background: WS_CREAM }}>
              <Icon name="redo" id="respinButton-desktop" onClick={this.clickRespin} />
              <big><strong>{this.props.label}</strong></big>
            </Segment>
          }
          <Segment attached={this.props.label ? "bottom" : undefined} basic={!this.props.label}>
            <Grid columns="equal" >
              <Grid.Row>
                {list2 && list2.length > 0 ?
                  <Grid.Column>
                    {list2}
                  </Grid.Column>
                  : null
                }
                <Grid.Column >
                  {this.props.label ? null : <Icon name="redo" id="respinButton" onClick={this.clickRespin} />}
                  {list}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Segment>
        </div>

        <br />
        <br />

      </div >
    );
  }

  private async clickRespin() {
    let first = this.state.first + this.state.nbrShown;
    if (first + this.state.nbrShown > this.props.names.length) {
      first = 0;
    }
    this.setState({ first });
  }

  private clickName(name: string) {
    // console.log("clickName: " + name);
    copyToClipboard(name);
    this.setState({ highlightName: name },
      () => { setTimeout(() => { this.setState({ highlightName: undefined }) }, 100) })
  }

}

export async function copyToClipboard(text: string) {
  await navigator.clipboard.writeText(text);
}
